module.exports = __webpack_public_path__ + "img/jiancaigy.761ba199.jpg";